module.exports = __webpack_public_path__ + "static/media/munch7.a4044efb.wav";